module.exports = __webpack_public_path__ + "img/hospital10.f8a975fa.png";